module.exports = __webpack_public_path__ + "img/whats.6324bb59.png";